/*
 * AwareVizExtReactApp.tsx
 * ===========
 * Sets up React DOM roots. Gets instantiated by AwareVizExtApp.ts.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, ConfigProvider, Layout, Tabs, theme } from "antd";
import "antd/dist/reset.css";
import { observer } from "mobx-react";
import React from "react";
import { createRoot } from "react-dom/client";
import styled from "styled-components";
import PlacesInsights from "../awareviz/PlacesInsights";
import PeopleInsights from "../awareviz/PeopleInsights";
const { Sider, Header, Content } = Layout;
const StyledLayout = styled(Layout) `
  background: transparent;
  right: 0;
`;
const StyledContent = styled(Content) `
  position: absolute;
  background: transparent;
  height: 100vh;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;
const StyledTopDiv = styled.div `
  position: absolute;
  margin-left: 10px;
  margin-top: 10px;
  width: 100%;
  pointer-events: all;
  z-index: 10;
`;
const LogoDiv = styled.div `
  position: absolute;
  margin: 10px;
`;
const CenteredDiv = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
const LoginDiv = styled.div `
  pointer-events: all;
`;
const StyledTabs = styled(Tabs) `
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: cyan !important;
  }
  .ant-tabs-tab:hover {
    color: cyan !important;
  }
  .ant-tabs-ink-bar {
    background-color: cyan !important; /* Red color for the ink bar */
  }
`;
let DOM = class DOM extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const tabItems = [
            { label: "TIMELINE", key: "timeline" },
            { label: "PLACES", key: "places", children: React.createElement(PlacesInsights, { userMap: this.props.app.userMap, activityInsights: this.props.app.activityInsights }) },
            { label: "PEOPLE", key: "people", children: React.createElement(PeopleInsights, { userMap: this.props.app.userMap, activityInsights: this.props.app.activityInsights }) },
            { label: "ACTIVITY", key: "activity" },
        ];
        return (React.createElement(ConfigProvider, { theme: {
                algorithm: theme.darkAlgorithm,
                components: {
                    Carousel: {
                        colorBgContainer: "white",
                        dotWidth: 30,
                        dotActiveWidth: 30,
                        arrowSize: 30,
                    },
                },
            } },
            React.createElement(StyledLayout, null,
                React.createElement(StyledContent, null,
                    this.props.app.authState === "unauthenticated" &&
                        React.createElement(CenteredDiv, null,
                            React.createElement(LoginDiv, null,
                                React.createElement(Button, { icon: React.createElement(GoogleIcon, null), style: {
                                        backgroundColor: "white",
                                        color: "rgba(0, 0, 0, 0.88)",
                                        borderColor: "rgba(0, 0, 0, 0.15)",
                                    }, onClick: () => { this.props.app.signIn(); } }, "Sign in With Google"))),
                    this.props.app.authState === "whitelisted" &&
                        React.createElement(StyledTopDiv, null,
                            React.createElement(LogoDiv, null,
                                React.createElement("img", { src: "assets/icons/asi-white.svg", width: "25px", height: "25px" })),
                            React.createElement(StyledTabs, { defaultActiveKey: "places", centered: true, items: tabItems })),
                    this.props.app.authState === "checking" &&
                        React.createElement(CenteredDiv, null, "Checking permissions..."),
                    this.props.app.authState === "denied" &&
                        React.createElement(CenteredDiv, null,
                            "You do not have permission to view this content.",
                            React.createElement(LoginDiv, { style: { marginTop: "20px" } },
                                React.createElement(Button, { icon: React.createElement(GoogleIcon, null), style: {
                                        backgroundColor: "white",
                                        color: "rgba(0, 0, 0, 0.88)",
                                        borderColor: "rgba(0, 0, 0, 0.15)",
                                    }, onClick: () => { this.props.app.signIn(); } }, "Sign in With Google")))))));
    }
};
DOM = __decorate([
    observer
], DOM);
export default class AwareVizReactApp {
    app;
    constructor(app) {
        this.app = app;
        const container = document.getElementById("dom");
        const root = createRoot(container);
        root.render(React.createElement(DOM, { app: this.app }));
    }
}
const GoogleIcon = () => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fill: "#EA4335", d: "M24 9.5c3.54 0 6.72 1.22 9.21 3.59l6.19-6.19C33.46 2.39 28.98 0 24 0 14.54 0 6.46 5.39 2.56 13.22l7.98 6.19C13.06 13.9 18.06 9.5 24 9.5z" }),
    React.createElement("path", { fill: "#4285F4", d: "M46.98 24c0-1.57-.15-3.09-.38-4.55H24v9.02h12.92c-.6 3.03-2.31 5.56-4.99 7.37l7.98 6.19C43.5 39.54 48 32.61 48 24z" }),
    React.createElement("path", { fill: "#34A853", d: "M24 48c6.48 0 11.93-2.13 15.96-5.74l-7.98-6.19c-2.07 1.34-4.72 2.13-7.98 2.13-5.94 0-10.94-4.4-12.79-10.91L2.56 34.78C6.46 42.61 14.54 48 24 48z" }),
    React.createElement("path", { fill: "#FBBC05", d: "M9.5 29.5c-.83-2.45-1.31-5-1.31-7.5s.48-5.05 1.31-7.5L2.56 13.22C.95 16.29 0 19.95 0 24s.95 7.71 2.56 10.78L9.5 29.5z" })));
